import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { ILoggerNoiseHistogram } from '@app/api/interfaces/chart-data/logger-noise-histogram';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export enum FpLoggerNoiseHistogramActionType {
  GetData = 'GetData',
  GetDataSuccesses = 'GetDataSuccesses',
  GetDataError = 'GetDataError',
  ToggleChartFullscreen = 'ToggleChartFullscreen',
}

export interface FpLoggerNoiseHistogramActionGetData {
  type: FpLoggerNoiseHistogramActionType.GetData;
  date: string | null;
  popupMainData: ILdLogger | null;
}

export interface FpLoggerNoiseHistogramActionGetDataSuccesses {
  type: FpLoggerNoiseHistogramActionType.GetDataSuccesses;
  date: string | null;
  popupMainData: ILdLogger | null;
  data: ILoggerNoiseHistogram[] | null;
}

export interface FpLoggerNoiseHistogramActionGetDataError {
  type: FpLoggerNoiseHistogramActionType.GetDataError;
  date: string | null;
  popupMainData: ILdLogger | null;
  error: IApiBaseErrorResponse;
}

export interface FpLoggerNoiseHistogramActionToggleChartFullscreen {
  type: FpLoggerNoiseHistogramActionType.ToggleChartFullscreen;
  synchronizeWithPopupId?: string;
}

export type FpLoggerNoiseHistogramActions =
  | FpLoggerNoiseHistogramActionGetData
  | FpLoggerNoiseHistogramActionGetDataSuccesses
  | FpLoggerNoiseHistogramActionGetDataError
  | FpLoggerNoiseHistogramActionToggleChartFullscreen;
